import { packageVersion } from "./packageVersion.js";
const versionSuffix = packageVersion.replace(/\./g, "-");
function formatToken(tokenName) {
  return `var(--${tokenName}-${versionSuffix})`;
}
const token = {
  white: formatToken("white"),
  "white-rgb": formatToken("white-rgb"),
  // Grays
  gray1000: formatToken("gray1000"),
  "gray1000-rgb": formatToken("gray1000-rgb"),
  gray900: formatToken("gray900"),
  gray800: formatToken("gray800"),
  gray700: formatToken("gray700"),
  gray600: formatToken("gray600"),
  gray500: formatToken("gray500"),
  gray400: formatToken("gray400"),
  gray300: formatToken("gray300"),
  gray200: formatToken("gray200"),
  gray100: formatToken("gray100"),
  gray75: formatToken("gray75"),
  gray50: formatToken("gray50"),
  gray25: formatToken("gray25"),
  gray10: formatToken("gray10"),
  // System colors
  blue1000: formatToken("blue1000"),
  blue900: formatToken("blue900"),
  blue800: formatToken("blue800"),
  blue700: formatToken("blue700"),
  blue600: formatToken("blue600"),
  blue500: formatToken("blue500"),
  "blue500-rgb": formatToken("blue500-rgb"),
  blue500a10: formatToken("blue500a10"),
  blue400: formatToken("blue400"),
  blue300: formatToken("blue300"),
  blue200: formatToken("blue200"),
  blue100: formatToken("blue100"),
  red400: formatToken("red400"),
  red500: formatToken("red500"),
  "red500-rgb": formatToken("red500-rgb"),
  red500a10: formatToken("red500a10"),
  red500a50: formatToken("red500a50"),
  red600: formatToken("red600"),
  red700: formatToken("red700"),
  yellow500: formatToken("yellow500"),
  "yellow500-rgb": formatToken("yellow500-rgb"),
  yellow500a10: formatToken("yellow500a10"),
  yellow600: formatToken("yellow600"),
  yellow700: formatToken("yellow700"),
  green500: formatToken("green500"),
  purple1000: formatToken("purple1000"),
  purple900: formatToken("purple900"),
  purple800: formatToken("purple800"),
  purple700: formatToken("purple700"),
  purple600: formatToken("purple600"),
  purple500: formatToken("purple500"),
  purple400: formatToken("purple400"),
  purple300: formatToken("purple300"),
  purple200: formatToken("purple200"),
  purple100: formatToken("purple100"),
  magenta1000: formatToken("magenta1000"),
  magenta900: formatToken("magenta900"),
  magenta800: formatToken("magenta800"),
  magenta700: formatToken("magenta700"),
  magenta600: formatToken("magenta600"),
  magenta500: formatToken("magenta500"),
  magenta400: formatToken("magenta400"),
  magenta300: formatToken("magenta300"),
  magenta200: formatToken("magenta200"),
  magenta100: formatToken("magenta100"),
  teal1000: formatToken("teal1000"),
  teal900: formatToken("teal900"),
  teal800: formatToken("teal800"),
  teal700: formatToken("teal700"),
  teal600: formatToken("teal600"),
  teal500: formatToken("teal500"),
  "teal500-rgb": formatToken("teal500-rgb"),
  teal500a10: formatToken("teal500a10"),
  teal400: formatToken("teal400"),
  teal300: formatToken("teal300"),
  teal200: formatToken("teal200"),
  teal100: formatToken("teal100"),
  // Brand colors
  brandPrimary700: formatToken("brandPrimary700"),
  brandPrimary600: formatToken("brandPrimary600"),
  brandPrimary500: formatToken("brandPrimary500"),
  "brandPrimary500-rgb": formatToken("brandPrimary500-rgb"),
  brandPrimary300: formatToken("brandPrimary300"),
  brandPrimary100: formatToken("brandPrimary100"),
  // Spacing
  /** 2px */
  spacing1: formatToken("spacing1"),
  /** 4px */
  spacing2: formatToken("spacing2"),
  /** 8px */
  spacing3: formatToken("spacing3"),
  /** 12px */
  spacing4: formatToken("spacing4"),
  /** 16px */
  spacing5: formatToken("spacing5"),
  /** 24px */
  spacing6: formatToken("spacing6"),
  /** 32px */
  spacing7: formatToken("spacing7"),
  /** 40px */
  spacing8: formatToken("spacing8"),
  /** 48px */
  spacing9: formatToken("spacing9"),
  // Layout
  /** 16px */
  layoutSpacing1: formatToken("layoutSpacing1"),
  /** 24px */
  layoutSpacing2: formatToken("layoutSpacing2"),
  /** 32px */
  layoutSpacing3: formatToken("layoutSpacing3"),
  /** 48px */
  layoutSpacing4: formatToken("layoutSpacing4"),
  /** 64px */
  layoutSpacing5: formatToken("layoutSpacing5"),
  /** 96px */
  layoutSpacing6: formatToken("layoutSpacing6"),
  /** 160px */
  layoutSpacing7: formatToken("layoutSpacing7"),
  // Border radius
  /** 2px */
  radiusSmall: formatToken("radiusSmall"),
  /** 5px */
  radiusMedium: formatToken("radiusMedium"),
  /** 8px */
  radiusLarge: formatToken("radiusLarge"),
  /** 50% */
  radiusCircle: formatToken("radiusCircle"),
  /** 9999px */
  radiusPill: formatToken("radiusPill"),
  /** Same as radiusMedium: 5px */
  radiusBase: formatToken("radiusBase"),
  /** Same as radiusBase: 5px */
  brandRadiusBase: formatToken("brandRadiusBase"),
  // Fonts
  fontStackBase: formatToken("fontStackBase"),
  brandFontStackBase: formatToken("brandFontStackBase"),
  fontSize25: formatToken("fontSize25"),
  fontSize50: formatToken("fontSize50"),
  fontSize75: formatToken("fontSize75"),
  fontSize100: formatToken("fontSize100"),
  fontSize200: formatToken("fontSize200"),
  fontSize300: formatToken("fontSize300"),
  fontSize400: formatToken("fontSize400"),
  fontSize500: formatToken("fontSize500"),
  fontSize600: formatToken("fontSize600"),
  fontSize700: formatToken("fontSize700"),
  fontSize800: formatToken("fontSize800"),
  fontSize900: formatToken("fontSize900"),
  fontSize1000: formatToken("fontSize1000"),
  fontSizeBase: formatToken("fontSizeBase"),
  lineHeightBase: formatToken("lineHeightBase"),
  lineHeightHeading: formatToken("lineHeightHeading"),
  lineHeightText: formatToken("lineHeightText"),
  gray900a: formatToken("gray900a"),
  gray800a: formatToken("gray800a"),
  gray700a: formatToken("gray700a"),
  gray600a: formatToken("gray600a"),
  gray500a: formatToken("gray500a"),
  gray400a: formatToken("gray400a"),
  gray300a: formatToken("gray300a"),
  gray200a: formatToken("gray200a"),
  gray100a: formatToken("gray100a"),
  gray75a: formatToken("gray75a"),
  gray50a: formatToken("gray50a"),
  gray25a: formatToken("gray25a"),
  // Aliases
  colorText: formatToken("colorText"),
  colorTextMuted: formatToken("colorTextMuted"),
  colorTextDisabled: formatToken("colorTextDisabled"),
  // Focus rings
  focusRingWidth: formatToken("focusRingWidth"),
  focusRingColorPrimary: formatToken("focusRingColorPrimary"),
  focusRingColorSecondary: formatToken("focusRingColorSecondary"),
  // Shadows
  colorShadow: formatToken("colorShadow"),
  elevationStatic: formatToken("elevationStatic"),
  elevation1: formatToken("elevation1"),
  elevation2: formatToken("elevation2"),
  elevation4: formatToken("elevation4"),
  elevation8: formatToken("elevation8"),
  elevation12: formatToken("elevation12"),
  elevation16: formatToken("elevation16"),
  elevation24: formatToken("elevation24"),
  // Button component
  componentButtonPrimaryBorderHover: formatToken("componentButtonPrimaryBorderHover"),
  componentButtonPrimaryBorderActive: formatToken("componentButtonPrimaryBorderActive"),
  componentButtonPrimaryBorderFocus: formatToken("componentButtonPrimaryBorderFocus"),
  componentButtonPrimaryBorderDisabled: formatToken("componentButtonPrimaryBorderDisabled"),
  componentButtonPrimaryColor: formatToken("componentButtonPrimaryColor"),
  componentButtonPrimaryColorHover: formatToken("componentButtonPrimaryColorHover"),
  componentButtonPrimaryColorActive: formatToken("componentButtonPrimaryColorActive"),
  componentButtonPrimaryColorFocus: formatToken("componentButtonPrimaryColorFocus"),
  componentButtonPrimaryColorDisabled: formatToken("componentButtonPrimaryColorDisabled"),
  componentButtonPrimaryFill: formatToken("componentButtonPrimaryFill"),
  componentButtonPrimaryFillHover: formatToken("componentButtonPrimaryFillHover"),
  componentButtonPrimaryFillActive: formatToken("componentButtonPrimaryFillActive"),
  componentButtonPrimaryFillFocus: formatToken("componentButtonPrimaryFillFocus"),
  componentButtonPrimaryFillDisabled: formatToken("componentButtonPrimaryFillDisabled"),
  componentButtonPrimaryFocusRing: formatToken("componentButtonPrimaryFocusRing"),
  componentButtonSecondaryBorder: formatToken("componentButtonSecondaryBorder"),
  componentButtonSecondaryBorderHover: formatToken("componentButtonSecondaryBorderHover"),
  componentButtonSecondaryBorderActive: formatToken("componentButtonSecondaryBorderActive"),
  componentButtonSecondaryBorderFocus: formatToken("componentButtonSecondaryBorderFocus"),
  componentButtonSecondaryBorderDisabled: formatToken("componentButtonSecondaryBorderDisabled"),
  componentButtonSecondaryColor: formatToken("componentButtonSecondaryColor"),
  componentButtonSecondaryColorHover: formatToken("componentButtonSecondaryColorHover"),
  componentButtonSecondaryColorActive: formatToken("componentButtonSecondaryColorActive"),
  componentButtonSecondaryColorFocus: formatToken("componentButtonSecondaryColorFocus"),
  componentButtonSecondaryColorDisabled: formatToken("componentButtonSecondaryColorDisabled"),
  componentButtonSecondaryFill: formatToken("componentButtonSecondaryFill"),
  componentButtonSecondaryFillHover: formatToken("componentButtonSecondaryFillHover"),
  componentButtonSecondaryFillActive: formatToken("componentButtonSecondaryFillActive"),
  componentButtonSecondaryFillFocus: formatToken("componentButtonSecondaryFillFocus"),
  componentButtonSecondaryFillDisabled: formatToken("componentButtonSecondaryFillDisabled"),
  componentButtonSecondaryFocusRing: formatToken("componentButtonSecondaryFocusRing"),
  componentButtonCleanBorderFocus: formatToken("componentButtonCleanBorderFocus"),
  componentButtonCleanBorderActive: formatToken("componentButtonCleanBorderActive"),
  componentButtonCleanColor: formatToken("componentButtonCleanColor"),
  componentButtonCleanColorHover: formatToken("componentButtonCleanColorHover"),
  componentButtonCleanColorActive: formatToken("componentButtonCleanColorActive"),
  componentButtonCleanColorFocus: formatToken("componentButtonCleanColorFocus"),
  componentButtonCleanColorDisabled: formatToken("componentButtonCleanColorDisabled"),
  componentButtonCleanFill: formatToken("componentButtonCleanFill"),
  componentButtonCleanFillHover: formatToken("componentButtonCleanFillHover"),
  componentButtonCleanFillActive: formatToken("componentButtonCleanFillActive"),
  componentButtonCleanFillFocus: formatToken("componentButtonCleanFillFocus"),
  componentButtonCleanFillDisabled: formatToken("componentButtonCleanFillDisabled"),
  componentButtonCleanFocusRing: formatToken("componentButtonCleanFocusRing"),
  componentButtonDangerBorderHover: formatToken("componentButtonDangerBorderHover"),
  componentButtonDangerBorderActive: formatToken("componentButtonDangerBorderActive"),
  componentButtonDangerBorderFocus: formatToken("componentButtonDangerBorderFocus"),
  componentButtonDangerBorderDisabled: formatToken("componentButtonDangerBorderDisabled"),
  componentButtonDangerColor: formatToken("componentButtonDangerColor"),
  componentButtonDangerColorHover: formatToken("componentButtonDangerColorHover"),
  componentButtonDangerColorActive: formatToken("componentButtonDangerColorActive"),
  componentButtonDangerColorFocus: formatToken("componentButtonDangerColorFocus"),
  componentButtonDangerColorDisabled: formatToken("componentButtonDangerColorDisabled"),
  componentButtonDangerFill: formatToken("componentButtonDangerFill"),
  componentButtonDangerFillHover: formatToken("componentButtonDangerFillHover"),
  componentButtonDangerFillActive: formatToken("componentButtonDangerFillActive"),
  componentButtonDangerFillFocus: formatToken("componentButtonDangerFillFocus"),
  componentButtonDangerFillDisabled: formatToken("componentButtonDangerFillDisabled"),
  componentButtonDangerFocusRing: formatToken("componentButtonDangerFocusRing"),
  componentDividerColor: formatToken("componentDividerColor"),
  componentCheckboxBorderUnchecked: formatToken("componentCheckboxBorderUnchecked"),
  componentCheckboxBorderUncheckedHover: formatToken("componentCheckboxBorderUncheckedHover"),
  componentCheckboxBorderUncheckedFocus: formatToken("componentCheckboxBorderUncheckedFocus"),
  componentCheckboxFillDisabled: formatToken("componentCheckboxFillDisabled"),
  componentCheckboxCheckmarkColorDisabled: formatToken("componentCheckboxCheckmarkColorDisabled"),
  componentRadioBorderUnchecked: formatToken("componentRadioBorderUnchecked"),
  componentRadioFillDisabled: formatToken("componentRadioFillDisabled"),
  componentRadioCheckmarkColorDisabled: formatToken("componentRadioCheckmarkColorDisabled"),
  componentRadioBorderUncheckedHover: formatToken("componentRadioBorderUncheckedHover"),
  // Pagination component
  componentPaginationBackground: formatToken("componentPaginationBackground"),
  componentPaginationElevation: formatToken("componentPaginationElevation"),
  // Tooltip
  componentTooltipBackground: formatToken("componentTooltipBackground"),
  componentTooltipShadow: formatToken("componentTooltipShadow"),
  componentTooltipTitleColor: formatToken("componentTooltipTitleColor"),
  componentTooltipSecondaryTextColor: formatToken("componentTooltipSecondaryTextColor"),
  componentTooltipTextColor: formatToken("componentTooltipTextColor")
};
export {
  token,
  versionSuffix
};
//# sourceMappingURL=token.js.map
